export const themes = {
	default: [
		"smartyAddress__base_default",
		"smartyAddress__color_dynamic",
		"smartyAddress__position_dynamic",
		"smartyAddress__font_size_medium",
		"smartyAddress__spacing_medium",
		"smartyAddress__typography_default",
	],
	light: [
		"smartyAddress__base_default",
		"smartyAddress__color_light",
		"smartyAddress__position_dynamic",
		"smartyAddress__font_size_medium",
		"smartyAddress__spacing_medium",
		"smartyAddress__typography_default",
	],
	dark: [
		"smartyAddress__base_default",
		"smartyAddress__color_dark",
		"smartyAddress__position_dynamic",
		"smartyAddress__font_size_medium",
		"smartyAddress__spacing_medium",
		"smartyAddress__typography_default",
	],
	none: [],
};
